import { useQuery } from '@tanstack/react-query'

import { getTrustdockIdentityVerifications } from '@src/api'
import { DefaultApiGetTrustdockIdentityVerificationsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchTrustdockIdentityVerifications = (
  params: DefaultApiGetTrustdockIdentityVerificationsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.trustdockIdentificationId,
    queryFn: () => getTrustdockIdentityVerifications(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_TRUSTDOCK_IDENTITY_VERIFICATIONS,
      params.trustdockIdentificationId,
    ],
  })
}
